<template>
  <div class="study_bottom">
    <div class="left_box">
      <div class="nav">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="活动目录" name="third">
            <!-- 购前必读部分,由于接口未完善暂时先隐藏 -->
            <div
              class="dayLook_box tips_box"
              v-if="myitem.lesson_before != null"
            >
              <div class="muluTitle">
                <div class="muluTitle_text">打卡学员购前必读（本节免费）</div>
                <div class="section_down" @click="down('tips')">
                  <span>{{ tipsFlag == false ? "展开" : "收起" }}</span>
                  <i
                    class="iconfont icon-jiantoudown"
                    :class="[tipsFlag == false ? 'icoDwon' : 'icoUp']"
                  ></i>
                </div>
              </div>
              <div class="tipsContentBox" v-show="tipsFlag">
                <div>
                  <tips
                    v-for="(item, index) in myitem.lesson_before"
                    :key="index"
                    :obj="item"
                    :MYnumber="index + 1"
                    :camp="mycamp_id"
                  ></tips>
                </div>
              </div>
            </div>
            <!-- 目录部分 -->
            <div class="dayLook_box">
              <div class="muluTitle">
                <div class="muluTitle_text">打卡任务</div>
                <div class="section_down" @click="down('mulu')">
                  <span>{{ muluFlag == false ? "展开" : "收起" }}</span>
                  <i
                    class="iconfont icon-jiantoudown"
                    :class="[muluFlag == false ? 'icoDwon' : 'icoUp']"
                  ></i>
                </div>
              </div>

              <div class="mulu" v-if="empty1" v-show="muluFlag">
                <!-- 上次学到部分 -->
                <div class="last_box" v-if="myitem.last_learn != null">
                  上次学到：
                  <span class="colorOrange">
                    <!-- 作业打卡显示第几课 天数打卡显示第几天 -->
                    <span v-if="myitem.detail.sign_type == '作业打卡'"
                      >第 {{ myitem.last_learn.day }} 课
                    </span>
                    <span v-else>DAY {{ myitem.last_learn.day }}</span>
                    {{ myitem.last_learn.lesson_name }}
                  </span>
                </div>
                <DayLook
                  v-for="(item, index) in myitem.lessons"
                  :key="index"
                  :day="item.day"
                  :myitem="item"
                  :is_apply="myitem.is_apply"
                  :is_login="myitem.is_login"
                  :status="myitem"
                ></DayLook>
              </div>
              <!-- 空状态 -->
              <div v-else style="width: 100%" v-show="muluFlag">
                <div
                  style="
                    margin: auto;
                    width: 18rem;
                    height: 18rem;
                    text-align: center;
                  "
                >
                  <img
                    style="width: 90%; height: 90%"
                    src="https://fview.5kjs.com/activity/21sign/image/pc/kong.png"
                    alt=""
                  />
                  <div style="color: #333333">暂时没有数据</div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="打卡日记" name="fourth">
            <!-- 写日记的弹框 -->
            <myDiaLog
              :camp_id="mycamp_id"
              ref="comment"
              @addShar="AddShar($event)"
              @cardOk="myCardOk($event)"
            ></myDiaLog>
            <!-- 打卡日记内容部分 -->
            <div class="shart_box">
              <!-- 当前任务部分 -->
              <div class="today" v-if="todyTask != null">
                <!-- 标题部分 -->
                <div class="today_title">
                  <div class="left_today_title">
                    <img src="@/assets/ico/renwu.png" alt="" />
                    当前任务
                    <div class="todayType">{{ todyTask.lesson_type | IStype }}</div>
                    <!-- 当前任务是否已打卡 -->
                    <div
                      class="MYcarStatus"
                      :class="[todyTask.sign_status == '1' ? 'cardOk' : '']"
                    >
                      <span class="duigou">{{
                        todyTask.sign_status != "1" ? "未打卡" : "已打卡"
                      }}</span>
                    </div>
                  </div>
                  <div class="right_today_title" @click="activeName = 'third'">
                    全部任务<span v-if="myitem.lessons"
                      >({{ myitem.lessons.length }})</span
                    >
                  </div>
                </div>
                <!-- 下方内容部分 -->
                <div class="today_box">
                  <!-- 下方第一行 -->
                  <div class="onRow">
                    <div class="onRow_title">
                      {{ todyTask.lesson_name }}
                    </div>
                    <!-- 非章节则显示去学习按钮  todyTask.is_question_punch 为打卡先决条件判断 1未做题 2未写日记 3已打卡 -->
                    <div
                      class="Go"
                      v-if="todyTask.lesson_type != 'knowledge'"
                      v-show="todyTask.is_question_punch == '1'"
                      @click="jump(todyTask)"
                    >
                      去学习
                    </div>
                    <!-- 章节则显示展开按钮 -->
                    <div class="zankai" v-else>
                      <span
                        v-show="todayTaskDown"
                        @click="todayTaskDown = !todayTaskDown"
                        >收起 <i class="iconfont icon-jiantou1"></i
                      ></span>
                      <span
                        v-show="!todayTaskDown"
                        @click="todayTaskDown = !todayTaskDown"
                        >展开 <i class="iconfont icon-jiantoudown"></i
                      ></span>
                    </div>
                  </div>
                  <!-- 下方第二行已经完成学习任务显示的按钮 -->
                  <!-- 非章节显示内容 -->
                  <div
                    class="classes"
                    v-if="todyTask.lesson_type != 'knowledge'"
                    v-show="todyTask.is_question_punch != '1'"
                  >
                    <!-- 刷题类型 -->
                    <div
                      class="twoRow"
                      v-if="
                        todyTask.lesson_type == 'classes' ||
                        todyTask.lesson_type == 'paper'
                      "
                    >
                      <div class="two_item" @click="jump(todyTask)">
                        再刷一次
                      </div>
                      <div
                        class="two_item"
                        style="background: #ffba61"
                        @click="jumpResult(todyTask)"
                      >
                        答题结果
                      </div>
                      <div
                        class="two_item"
                        style="background: #ff8673"
                        @click="myshare(todyTask)"
                      >
                        写日记 <i class="iconfont icon-bi1"></i>
                      </div>
                    </div>
                    <!-- 图文类型 -->
                    <div
                      class="twoRow"
                      v-else-if="todyTask.lesson_type == 'graphic_library'"
                    >
                      <div class="two_item" @click="jump(todyTask)">
                        再刷一次
                      </div>
                      <div
                        class="two_item"
                        style="background: #ff8673"
                        @click="myshare(todyTask)"
                      >
                        写日记 <i class="iconfont icon-bi1"></i>
                      </div>
                    </div>
                    <!-- 视频类型 -->
                    <div class="twoRow" v-else>
                      <div class="two_item" @click="jump(todyTask)">
                        再看一次
                      </div>
                      <div
                        class="two_item"
                        style="background: #ff8673"
                        @click="myshare(todyTask)"
                      >
                        写日记 <i class="iconfont icon-bi1"></i>
                      </div>
                    </div>
                  </div>
                  <!-- 章节显示内容 -->
                  <div
                    class="knowledge"
                    v-if="todyTask.lesson_type == 'knowledge' && todayTaskDown"
                  >
                    <div
                      class="knowledge_item"
                      v-for="(item, index) in todyTask.leve"
                      :key="index"
                    >
                      <div class="item_left">
                        <div
                          class="ico"
                          :class="item.is_camp == 1 ? 'show' : ''"
                        >
                          <i class="iconfont icon-yuangou"></i>
                        </div>
                        <div class="Number">{{ (index + 1) | zero }}</div>
                        <div class="title">{{ item.title }}</div>
                      </div>
                      <div class="item_right">
                        <!-- 已完成学习内容显示 -->
                        <div class="is_ok" v-if="item.is_camp == 1">
                          <div
                            class="btn"
                            style="background: #ffc052"
                            @click="jump(todyTask, item.id)"
                          >
                            再刷一次
                          </div>
                          <div
                            class="btn"
                            style="background: #28bfa7"
                            @click="jumpResult(todyTask)"
                          >
                            答题结果
                          </div>
                        </div>
                        <!-- 未完成学习内容情况+ -->
                        <div
                          class="is_ok"
                          v-else
                          @click="jump(todyTask, item.id)"
                        >
                          <div class="btn" style="background: #ff7d3a">
                            开始刷题
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      v-show="todyTask.is_question_punch != 1"
                      class="two_item"
                      style="background: #ff8673"
                      @click="myshare(todyTask)"
                    >
                      写日记 <i class="iconfont icon-bi1"></i>
                    </div>
                  </div>
                </div>

                <!-- 完成学习内容但是没有写日记部分 -->
                <div
                  class="diary"
                  v-show="
                    todyTask.is_question_punch == '2' && sginCard == false
                  "
                >
                  完成作业并发表日记才算打卡成功哦~
                  <span class="GoDiary" @click="myshare(todyTask)"
                    >去写日记</span
                  >
                  <i class="iconfont icon-jiantou"></i>
                </div>
              </div>
              <!-- 其他学员打卡日记部分 -->
              <div class="share_comment_box">
                <!-- 标题部分 -->
                <div class="share_comment_title">
                  <div class="left_today_title">
                    <img src="@/assets/ico/riji.png" alt="" /> 打卡日记
                    <span v-if="comment.count">({{ comment.count }})</span>
                  </div>
                  <div class="right_today_title" @click="activeName = 'third'">
                    <el-select v-model="CardOptionsValue" placeholder="请选择">
                      <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </div>
                <div class="share_comment" v-if="empty2">
                  <shareCard
                    v-for="item in comment.list"
                    :key="item.share_id"
                    :myitem="item"
                  ></shareCard>
                </div>
                <router-link :to="shareMore" v-if="empty2">
                  <div class="more" v-if="empty2 || comment.list.length < 3">
                    查看更多打卡日记<i class="iconfont icon-jiantou"></i></div
                ></router-link>

                <!-- 空状态 -->
                <div v-else style="width: 100%">
                  <div
                    style="
                      margin: auto;
                      width: 18rem;
                      height: 18rem;
                      text-align: center;
                    "
                  >
                    <img
                      style="width: 90%; height: 90%"
                      src="https://fview.5kjs.com/activity/21sign/image/pc/kong.png"
                      alt=""
                    />
                    <div style="color: #333333">暂时没有数据</div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane name="second">
            <span slot="label" @click="myseeClear()">
              <el-badge
                :value="myDashBoadr.is_see"
                class="item"
                :hidden="myDashBoadr.is_see == 0 ? true : false"
                >课程消息</el-badge
              >
            </span>
            <div class="xiangqing">
              <courseInfo
                v-for="(item, index) in myitem.lesson_log"
                :key="index"
                :myitem="item"
              ></courseInfo>
            </div>
          </el-tab-pane>
          <el-tab-pane label="资料下载" name="ziliao" v-if="mydata != null">
            <div v-if="mydata != null">
              <div
                class="data_box"
                v-for="item in mydata"
                :key="item.file_id"
                @click="download(item.file_id, item.name)"
              >
                <div class="data">
                  <div class="data_left">
                    <div class="ico_tuwen">
                      <i class="iconfont icon-xuexiziliao"></i>
                    </div>
                    <div class="data_name">{{ item.name }}</div>
                  </div>
                  <div class="data_right">
                    <div class="btn">下载</div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 空状态 -->
            <div v-else style="width: 100%">
              <div
                style="
                  margin: auto;
                  width: 18rem;
                  height: 18rem;
                  text-align: center;
                "
              >
                <img
                  style="width: 90%; height: 90%"
                  src="https://fview.5kjs.com/activity/21sign/image/pc/kong.png"
                  alt=""
                />
                <div style="color: #333333">暂时没有数据</div>
              </div>
            </div>
          </el-tab-pane>
                    <!-- 网课赠送 -->
          <el-tab-pane
            label="赠课列表"
            name="giveClass"
            v-if="giveClassList != null && giveClassList.length != 0"
          >
            <div class="giveClass_box">
              <div v-for="(item, index) in giveClassList" :key="item.id">
                <giveClass @freeUpdate='getGiveClass()' :isApply="myitem.is_apply" :item="item" :num="index + 1"></giveClass>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="right_box">
      <!-- 数据仪表盘部分 -->
      <div class="studyData">
        <div class="studyData_top">
          <!-- 常见问题 -->
          <div class="studyData_top_item" @click="GoIssue()">
            <div class="img_box" style="background: #fe8636">
              <i class="iconfont icon-changjianwenti"></i>
            </div>
            <div class="text">常见问题</div>
          </div>
          <!-- 排行榜和日历部分 -->
          <div class="studyData_top_item" @click="topNumberFlageChange()">
            <!-- topNumberFlage为是否显示排行榜 -->
            <div
              class="img_box"
              :style="topNumberFlage ? 'background: #2DCBD5' : ''"
            >
              <i
                class="iconfont"
                :class="topNumberFlage ? 'icon-renwujindu' : 'icon-paihangbang'"
              ></i>
            </div>
            <div class="text">{{ topNumberFlage ? "打卡进度" : "排行榜" }}</div>
          </div>
          <!-- 我的日记 -->
          <div
            class="studyData_top_item"
            @click="GoHome(myitem.detail.user_id)"
          >
            <div class="img_box" style="background: #ff8673">
              <i class="iconfont icon-riji"></i>
            </div>
            <div class="text">我的日记</div>
          </div>
          <!-- 今日分享部分 -->
          <div class="studyData_top_item" @click="todayFn()">
            <div class="img_box" style="background: #26d3bc">
              <i class="iconfont icon-fenxiang"></i>
            </div>
            <div class="text">今日分享</div>
          </div>
        </div>
        <dashBoadr
          :myDashBoadr="myDashBoadr"
          v-if="shuaxing"
          v-show="!topNumberFlage"
        ></dashBoadr>
        <!-- 新增的排行榜部分 -->
        <div class="topSearch_box" v-show="topNumberFlage">
          <topSearch></topSearch>
        </div>
      </div>
      <div>
        <linkTeacher :mykefu="myitem.kefu"></linkTeacher>
      </div>
      <!-- 微信二维码加群部分 -->
      <div class="qrCode" v-if="QrCodeFlag">
        <div>打卡微信群</div>
        <div class="qr">
          <img :src="myitem.kefu_group.kefu_group" alt="" />
        </div>
      </div>
    </div>

    <!-- 打卡成功的显示框 Start -->
    <el-dialog
      :visible.sync="cardModle"
      width="30%"
      class="cardModle"
      v-if="cardImg != null"
      @closed="dialogClose"
    >
      <!-- 用来撑开盒子 -->
      <img
        src="https://fview.5kjs.com/activity/21sign/image/pc/cardOk.png"
        alt=""
        class="cardOk_img"
      />
      <!-- 悬浮打卡内容 -->
      <div class="cardTime">{{ cardImg.created_at }}</div>
      <!-- 打卡题目部分 -->
      <div class="cardTitle">{{ cardImg.class_name }}</div>
    </el-dialog>

    <!-- 打卡成功日记图片 Start -->
    <el-dialog
      :visible.sync="cardImgModle"
      width="23.4375rem"
      class="cardImg"
      v-if="cardImg != null"
    >
      <!-- 用来撑开盒子 -->
      <img :src="cardImg.share_img" alt="" class="cardOk_img" />
      <!-- <img src="@/assets/test.png" alt="" class="cardOk_img" /> -->
    </el-dialog>

    <!-- 当用户完成打卡内容但是没有写日志时提示的弹框 -->
    <el-dialog :visible.sync="editCard" width="30%" class="editCard">
      <div class="editCard_box">
        <div class="editCard_box_top">
          <img src="@/assets/ico/editCard.png" alt="" />
          <div class="text">
            <p class="top">你还没有写日记哦</p>
            <p class="bottom">完成作业，并发表日记即完成打卡~</p>
          </div>
        </div>
        <div class="editCard_box_bottom">
          <div class="btn" @click="myshare(todyTask)">去写日记</div>
        </div>
      </div>
    </el-dialog>

    <!-- 用户尚未完成学习任务的弹框 -->
    <el-dialog :visible.sync="StudyCard" width="25%" class="editCard">
      <div class="editCard_box">
        <div class="editCard_box_top">
          <img src="@/assets/ico/GoStudy.png" alt="" />
          <div class="text">
            <p class="top">
              {{
                myitem.detail.sign_type == "作业打卡"
                  ? "任务未完成"
                  : "今日任务未完成"
              }}
            </p>
            <p class="jindu" v-if="myitem.detail.sign_type == '作业打卡'">
              当前进度:{{ cardNum }}/{{ myitem.lessons.length }}
            </p>
          </div>
        </div>
        <div class="editCard_box_bottom">
          <div
            class="btn"
            @click="
              activeName = 'fourth';
              StudyCard = false;
            "
          >
            去学习
          </div>
        </div>
      </div>
    </el-dialog>

    <!-- 今日分享图片 Start -->
    <el-dialog
      :visible.sync="todayShare"
      width="23.4375rem"
      class="cardImg"
      v-if="todayShare"
    >
      <!-- 用来撑开盒子 -->
      <img :src="todyTask.share_img" alt="" class="cardOk_img" />
      <!-- <img src="@/assets/test.png" alt="" class="cardOk_img" /> -->
    </el-dialog>
  </div>
</template>

<script>
import linkTeacher from "@/components/text_child/link_teacher.vue";
import courseInfo from "@/components/detail_child/courseInfo.vue";
import myDiaLog from "@/components/myDiaLog.vue";
import DayLook from "@/components/detail_child/DayLook.vue";
import shareCard from "@/components/shareCard.vue";
import dashBoadr from "@/components/detail_child/dashBoadr.vue";
import { mapActions } from "vuex";
import topSearch from "@/components/topSearch.vue";
import tips from "@/components/detail_child/tips.vue";
// import download from "downloadjs"; // 引用下载插件
import giveClass from "@/components/detail_child/giveClass.vue";

export default {
  components: {
    DayLook,
    shareCard,
    myDiaLog,
    dashBoadr,
    courseInfo,
    linkTeacher,
    topSearch,
    tips,
    giveClass
  },
  name: "study_bottom",
  props: {
    // 接收训练营数据
    myitem: {
      type: Object,
      default: () => {},
    },
    // 接收评论数据
    comment: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      // 当前活跃的窗口
      activeName: "third",
      // activeName: "fourth",
      // dashBoadr 当前用户仪表盘数据
      myDashBoadr: {},
      // 空状态
      // 目录空状态
      empty1: true,
      // 分享日记空状态
      empty2: true,
      // 训练营ID
      mycamp_id: this.$route.params.id,
      // 仪表盘部分数据刷新
      shuaxing: true,
      token: localStorage.getItem("token"),
      agency_id: localStorage.getItem("agency_id"),
      // 下载资料列表
      mydata: null,
      // 打卡类型排序的下拉框
      options: [
        {
          value: "1",
          label: "点赞数",
        },
        {
          value: "2",
          label: "发表时间",
        },
        {
          value: "3",
          label: "评论时间",
        },
      ],
      CardOptionsValue: "2",
      // 当前任务章节下拉框控件
      todayTaskDown: false,
      // 打卡提示框
      cardModle: false,
      // 打卡成功图
      cardImgModle: false,
      // 打卡成功的图片地址
      cardImg: null,
      // 当前是否已经打卡且状态更新隐藏没有打卡的提示
      sginCard: false,
      // 加群二维码变量
      QrCodeFlag: false,
      // 右侧仪表盘是显示排行榜还是显示日历
      topNumberFlage: false,
      // 当用户完成学习任务但是没有写打卡日志时的提示框
      editCard: false,
      // 当用户没有完成学习任务时的弹框
      StudyCard: false,
      // 今日分享图片
      todayShare: false,
      // 目录是否展开
      muluFlag: true,
      // 购前必读
      tipsFlag: true,
      // 赠课列表
      giveClassList:null
    };
  },
  methods: {
    ...mapActions(["ifLogin"]),
    // 实时添加分享
    AddShar(event) {
      if (this.comment.list != null) {
        this.comment.list.unshift(event);
      } else {
        this.comment.list = [];
        this.comment.list.unshift(event);
        this.empty2 = true;
      }
    },
    // tab栏切换
    handleClick(tab, event) {
      // console.log(tab, event);
      return tab, event;
    },
    // 分享按钮判断是否登录
    async myshare(item) {
      // 将提示用户去写日记的模态框隐藏
      this.editCard = false;
      // 将当前选项栏切换到打卡日记栏
      this.activeName = "fourth";

      var status = await this.ifLogin(this);
      if (status) {
        if (item != null) {
          console.log(item);
          this.$refs.comment.less_camp_id = item.lesson_id; //打卡的时候需要传 打卡id 课程id
          this.$refs.comment.punch_clock = 1; //打卡识别参数为1的时候为打卡分享，但是后台做了判断，所以每个分享都带上这个参数
          this.$refs.comment.record_id = item.record_id;
        } else {
          console.log("kong");
        }
        this.$refs.comment.open();
      }
    },
    // 根据当前训练营ID请求当前用户仪表盘信息
    getCampUserLog() {
      this.$axios
        .get("/getCampUserLog", {
          params: {
            token: this.token,
            agency_id: this.agency_id,
            camp_id: this.mycamp_id,
          },
        })
        .then((doc) => {
          this.shuaxing = false;
          this.myDashBoadr = doc;
          // 向上返回学习进度
          this.$emit("classBar", doc.learn_rate);
          setTimeout(() => {
            this.shuaxing = true;
          }, 200);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 请求下载资料列表
    getCampFiles() {
      this.$axios
        .get("/getCampFiles", {
          params: {
            token: this.token,
            agency_id: this.agency_id,
            camp_id: this.mycamp_id,
          },
        })
        .then((doc) => {
          this.mydata = doc.files;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 下载资料
    download(filesId, filesName) {
      this.$axios
        .get("/campFileDownload", {
          params: {
            token: this.token,
            agency_id: this.agency_id,
            file_id: filesId,
          },
        })
        .then((doc) => {
          // window.location.href = doc.url
          let houzui = doc.url.split(".");
          houzui = houzui[houzui.length - 1];
          this.downloadFile(doc.url, filesName + "." + houzui);

          // download(doc.url, filesName + "." + houzui);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //资料下载
    downloadFile(url, fileName) {
      var x = new XMLHttpRequest();
      x.open("GET", url, true);
      x.responseType = "blob";
      x.onload = function () {
        var url = window.URL.createObjectURL(x.response);
        var a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
      };
      x.send();
    },
    // 清除课程消息的角标小红点
    myseeClear() {
      this.$axios
        .get("/getCampLogSee", {
          params: {
            token: this.token,
            agency_id: this.agency_id,
            camp_id: this.mycamp_id,
          },
        })
        .then((doc) => {
          if (doc.message == "成功") {
            this.myDashBoadr.is_see = 0;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 当前任务跳转学习中间页
    jump(item, knowledge_id) {
      // 非章节做题
      if (item.lesson_type == "paper") {
        this.$router.push({
          path: `/text/${item.lesson_id}`,
          query: { camp: this.mycamp_id },
        });
        // 章节做题
      } else if (item.lesson_type == "knowledge") {
        this.$router.push({
          path: `/text/${item.lesson_id}`,
          query: { knowledge_id: knowledge_id, camp: this.mycamp_id },
        });
      } else if (item.lesson_type == "graphic_library") {
        this.$router.push({
          path: `/text/${item.lesson_id}`,
          query: { camp: this.mycamp_id, tuwen: true },
        });
        // 图文打卡类型
        // this.$router.push({
        //   path: `/Detail/imageText/${this.mycamp_id}`,
        //   query: {
        //     lesson_id: item.lesson_id,
        //     camp: this.mycamp_id,
        //     pattern_id: item.pattern_id,
        //   },
        // });
      } else {
        // 视频直播类型
        this.$router.push({
          path: `/video/${item.lesson_id}`,
          query: { camp: this.mycamp_id },
        });
      }
    },
    //查看做题结果
    jumpResult(item) {
      if (item.lesson_type == "paper") {
        this.$router.push({
          path: `/text/${item.lesson_id}`,
          query: { camp: this.mycamp_id, status: 1 },
        });
        // 章节做题
      } else if (item.lesson_type == "knowledge") {
        this.$router.push({
          path: `/text/${item.lesson_id}`,
          query: {
            knowledge_id: item.pattern_id,
            camp: this.mycamp_id,
            status: 1,
          },
        });
        // 视频直播类型
      } else {
        this.$router.push({
          path: `/video/${item.lesson_id}`,
          query: { camp: this.mycamp_id },
        });
      }
    },
    // 打卡成功之后触发打卡成功的元素
    myCardOk(item) {
      this.cardModle = true;
      this.cardImg = item;
      this.cardImgModle = true;
      // 将提示写日记的框给去除
      this.sginCard = true;
    },
    // 切换右侧仪表盘是显示日历还是显示排行榜
    topNumberFlageChange() {
      this.topNumberFlage = !this.topNumberFlage;
    },
    // 跳转我的日记
    GoHome(item) {
      this.$router.push({
        path: `/home/${item}`,
        query: {
          camp: this.mycamp_id,
          user_id_to: item,
        },
      });
    },
    //今日分享部分图片
    todayFn() {
      // 如果今日分享图片为空则提示今日还未打卡
      if (!this.todyTask) {
        this.$message({
          message: "您今日还未打卡噢~",
          type: "warning",
        });
        return;
      }
      if (this.todyTask.share_img == null) {
        this.$message({
          message: "您今日还未打卡或者当前打卡图还未生成",
          type: "warning",
        });
        return;
      }

      this.todayShare = true;
    },
    // 常见问题向上调用方法
    GoIssue() {
      this.$emit("issue");
    },
    // 打卡成功弹框弹出之后关闭弹窗时去除back属性
    dialogClose() {
      let url = window.location.href;
      url = url.replace(/type=back/g, "");
      window.location.href = url;
      console.log("触发关闭");
    },
    // 活动目录的展开与收起动作
    down(item) {
      if (item == "mulu") {
        this.muluFlag = !this.muluFlag;
      } else if (item == "tips") {
        this.tipsFlag = !this.tipsFlag;
      }
    },
        // 请求赠课列表
    getGiveClass() {
      this.$axios
        .get("/getCampFree", {
          params: {
            token: this.token,
            agency_id: this.agency_id,
            camp_id: this.mycamp_id,
          },
        })
        .then((doc) => {
          this.giveClassList = doc.free;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    this.getCampUserLog();
    // 判断是否从做题结算页的去分享按钮过来的

    // 首先计算出当前日期
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let strDate = date.getDate();
    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }
    // 当前日期
    let currentdate = `# ${year}年${month}月${strDate}日  完成打卡任务! # `;


    if (this.$route.query.type == "back" && this.$route.query.active_s != '1') {
      // 如果是从做题结算页直接过来的需要等数据加载完毕之后再显示
      var that = this;
      this.$refs.comment.open();
      // 判断当前数据清洗是否已经完毕，等数据清洗完毕之后再显示发布分享弹框
      let Auto = setInterval(() => {
        if (that.todyTask != null) {
          clearInterval(Auto);
          that.$refs.comment.less_camp_id = that.todyTask.lesson_id; //打卡的时候需要传 打卡id 课程id
          that.$refs.comment.record_id = that.todyTask.record_id;
          // 如果当前状态为2则是已完成学习任务进入打卡分享
          if (that.todyTask.is_question_punch == 2) {
            that.$refs.comment.NoEditText = currentdate;
            that.$refs.comment.punch_clock = 1; //打卡识别参数为1的时候为打卡分享，但是后台做了判断，所以每个分享都带上这个参数
          }
          // 图文打卡没有状态为2
          if (
            that.todyTask.lesson_type == "graphic_library" &&
            that.todyTask.is_question_punch == 1
          ) {
            that.$refs.comment.imageText = true; //是否为图文打卡模式
            that.$refs.comment.NoEditText = currentdate;
            that.$refs.comment.punch_clock = 1; //打卡识别参数为1的时候为打卡分享，但是后台做了判断，所以每个分享都带上这个参数
          }
          that.activeName = "fourth";
          
        }
      }, 200);
    } else if (this.$route.query.active_s != '1') {
      // 如果是从做题结算页直接过来的需要等数据加载完毕之后再显示
      let that = this;
      // 判断当前数据清洗是否已经完毕，等数据清洗完毕之后再显示发布分享弹框
      let Auto = setInterval(() => {
        console.log(that.todyTask)
        if (that.todyTask != null) {
          clearInterval(Auto);
          that.$refs.comment.less_camp_id = that.todyTask.lesson_id; //打卡的时候需要传 打卡id 课程id
          that.$refs.comment.punch_clock = 1; //打卡识别参数为1的时候为打卡分享，但是后台做了判断，所以每个分享都带上这个参数
          that.$refs.comment.record_id = that.todyTask.record_id;

          // 如果当前任务状态码为2则表示用户完成了学习任务，但是没有写日志，弹框提示用户
          if (that.todyTask.is_question_punch == 2) {
            that.$refs.comment.NoEditText = currentdate;
            that.editCard = true;
          }
          // 如果当前任务状态码为1则表示学员没有完成学习任务，弹框提示用户
          if (that.todyTask.is_question_punch == 1) {
            that.StudyCard = true;
          }
        }else if(that.todyTask == null){
          if(this.$route.query.lesson_id != null && localStorage.getItem('less_camp_id') == null) {
            clearInterval(Auto);
            that.$refs.comment.less_camp_id = this.$route.query.lesson_id; //打卡的时候需要传 打卡id 课程id
            that.$refs.comment.punch_clock = 1; //打卡识别参数为1的时候为打卡分享，但是后台做了判断，所以每个分享都带上这个参数
            that.$refs.comment.record_id = this.$route.query.record_id;

            // 如果当前任务状态码为2则表示用户完成了学习任务，但是没有写日志，弹框提示用户
            that.$refs.comment.NoEditText = currentdate;
            that.editCard = true;
            localStorage.setItem('less_camp_id', this.$route.query.lesson_id)
            localStorage.setItem('record_id', this.$route.query.record_id)
            localStorage.setItem('camp_idst', this.$route.query.camp)
          }
          if(this.$route.query.lesson_id != null && localStorage.getItem('less_camp_id') != null) {
              localStorage.removeItem('less_camp_id')
              localStorage.removeItem('record_id')
              this.$router.push({path:'/Detail/study/' +  localStorage.getItem('camp_idst'),query:{camp_id: localStorage.getItem('camp_idst')}});
          }
        }
      }, 200);
    }

    this.getCampFiles();
    // 请求赠课列表
    this.getGiveClass()

    if (this.$route.query.active_s == "1") {
      this.activeName = 'second'
    }
  },
  created (){
    if (this.$route.query.active_s == "1") {
      this.activeName = 'second'
    }
  },
  watch: {
    myitem(val) {
      if (val.lessons.length != 0) {
        this.empty1 = true;
      } else {
        this.empty1 = false;
      }

      // 判断当前是否有加群二维码
      if (val.kefu_group != null) {
        this.QrCodeFlag = true;
        // console.log(val.kefu_group);
        console.log(this.QrCodeFlag);
      } else {
        this.QrCodeFlag = false;
      }
    },
    comment(val) {
      if (val.list != null) {
        this.empty2 = true;
      } else {
        this.empty2 = false;
      }
    },
    // 监控打卡日记的排序方式并实时更新数据
    CardOptionsValue(val) {
      this.$emit("updataShar", val);
    },
  },
  computed: {
    shareMore() {
      return "/Detail/Introduce/" + this.mycamp_id;
    },
    // 清洗当前任务的数据
    todyTask() {
      // 首先计算出当前日期
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      let strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      // 当前日期
      let currentdate = `${year}-${month}-${strDate}`;

      let todayTask = null;

      // 区分天数打卡和作业打卡进行数据清洗
      if (this.myitem.lessons) {
        // 如果是天数打卡则根据当前时间对数据进行清洗
        if (this.myitem.detail.sign_type == "天数打卡") {
          this.myitem.lessons.forEach((element) => {
            if (element.endOfDate == currentdate) {
              todayTask = element;
            }
          });
        } else if (this.myitem.detail.sign_type == "作业打卡") {
          let lessons = this.myitem.lessons;

          // 特殊情况图文跳跃性打卡
          if (
            this.$route.query.imageText != null &&
            this.$route.query.type == "back"
          ) {
            for (let a = 0; a < lessons.length; a++) {
              if (lessons[a].day == this.$route.query.imageText) {
                todayTask = lessons[a];
                console.log(todayTask);
                break;
              }
            }
          }

          // 这种方案下分为两种情况为了兼容跳越打卡首先循环状态为2也就是以完成学习任务但是没有打卡的状态
          if (todayTask == null) {
            for (let a = 0; a < lessons.length; a++) {
              if (lessons[a].is_question_punch == 2) {
                todayTask = lessons[a];
                console.log(todayTask);
                break;
              }
            }
          }

          // 第二种情况 没有状态为二的打卡则循环出第一个状态为一的打卡
          if (todayTask == null) {
            for (let a = 0; a < lessons.length; a++) {
              if (lessons[a].is_question_punch == 1) {
                todayTask = lessons[a];
                break;
              }
            }
          }
        }
      }
      return todayTask;
    }, // 计算当前打卡总进度的已打卡数量
    cardNum() {
      let num = 0;
      if (this.myitem.lessons)
        this.myitem.lessons.forEach((element) => {
          if (element.sign_status == 1) {
            num++;
          }
        });
      return num;
    },
  },
  filters: {
    // 章节小节前面的序号补零
    zero(val) {
      let value = val;
      if (value < 10 && value > 0) {
        value = `0${value}`;
      }
      return value;
    },
    IStype(val) {
      var className = val;
      switch (val) {
        case "paper":
          className = "刷题打卡";
          break;
        case "classes":
          className = "视频打卡";
          break;
        case "package":
          className = "套餐打卡";
          break;
        case "live":
          className = "直播打卡";
          break;
        case "knowledge":
          className = "章节打卡";
          break;
        case "graphic_library":
          className = "图文打卡";
          break;
      }
      return className;
    },
  },
};
</script> 

<style lang="less" scoped>
// 打卡徽章部分
/deep/.cardModle {
  min-width: 1280px;
  .el-dialog {
    border-radius: 0.3125rem;

    .el-dialog__header {
      height: 0;
      padding: 0;
      // 关闭按钮
      .el-dialog__headerbtn {
        z-index: 9999;
      }
    }
    .el-dialog__body {
      position: relative;
      background-image: url("https://fview.5kjs.com/activity/21sign/image/pc/cardOk.png");
      background-repeat: no-repeat;
      background-size: 100%;
      // 用来撑开盒子
      .cardOk_img {
        width: 100%;
        opacity: 0;
      }
      // 悬浮打卡内容时间部分
      .cardTime {
        position: absolute;
        top: 55%;
        left: 0;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        font-size: 1.875rem;
        color: #fff;
      }
      // 悬浮打卡题目部分
      .cardTitle {
        position: absolute;
        bottom: 10%;
        left: 0;
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        font-size: 1.25rem;
      }
    }
  }
}

// 打卡日记图部分
/deep/.cardImg {
  .el-dialog {
    margin-top: 8vh !important;
  }
  .el-dialog__body {
    min-height: 41.6875rem;
  }
  img {
    max-width: 100%;
  }
}

// 当用户完成打卡内容但是没有写日志时提示的弹框
/deep/ .editCard {
  .el-dialog {
    width: 33.375rem;
    height: 21.875rem;
    background: #ffffff;
    border-radius: 0.125rem;
    // 右上角的关闭按钮
    .el-icon-close::before {
      font-size: 2rem;
      color: #969696;
    }
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__body {
      width: 100%;
      height: 100%;
      padding: 0;
    }
    .editCard_box {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      .editCard_box_top,
      .editCard_box_bottom {
        width: 100%;
      }

      .editCard_box_top {
        height: 15.625rem;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        border-bottom: 0.1875rem dashed #dde1e2;
        img {
          width: 8.125rem;
        }
        .text {
          text-align: center;
          .top {
            margin-top: 1.875rem;
            font-size: 1.125rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #000000;
          }
          .bottom {
            margin-top: 0.425rem;
            font-size: 0.875rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #6f6f6f;
          }
          .jindu {
            margin-top: 0.5rem;
          }
        }
      }
      .editCard_box_bottom {
        padding: 1.25rem 0;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .btn {
          cursor: pointer;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          width: 13.875rem;
          height: 2.9375rem;
          background: linear-gradient(90deg, #2ad4cd, #2fdac4);
          box-shadow: 0px 0.3125rem 0.8125rem 0px rgba(0, 163, 146, 0.34);
          border-radius: 1.5rem;
          font-size: 1.25rem;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
        }
      }
    }
  }
}

// 角标的样式
/deep/ .el-badge__content.is-fixed {
  transform: translateY(0%) translateX(100%);
}

.study_bottom {
  margin-top: 1.875rem;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  height: auto;
  // 下方左侧选项卡部分盒子
  .left_box {
    width: 51.25rem;
    // height: 63.75rem;
    height: auto;
    background: #ffffff;
    box-shadow: 0px 0.125rem 0.375rem 0px rgba(212, 214, 216, 0.3);
    // 选项卡部分
    .nav {
      width: 100%;
      /deep/ .el-tabs {
        .el-tabs__nav {
          padding-left: 2.625rem;
          .el-tabs__item {
            height: 3.5625rem;
            line-height: 3.5625rem;
            font-size: 1rem;
            font-family: "Microsoft YaHei";
            font-weight: 400;
            color: #afafaf;
          }
          // 当前活动字体颜色
          .is-active {
            color: #4e4e4e;
          }
          // 活动下标条
          .el-tabs__active-bar {
            margin-left: 2.625rem;
            background-color: #364348;
            height: 0.1875rem;
          }
          // 活动选项卡内容部分
        }
        .el-tabs__nav-wrap::after {
          height: 0.0625rem;
          background: #f0f1f1;
        }
      }
      // 详情介绍部分
      .xiangqing {
        padding: 1.1875rem;
        padding-top: 0;
        width: 100%;
        // height: 57.5rem;
        /deep/ .courseInfo:last-child {
          .content_box {
            border-bottom: none;
          }
        }
      }
      // 活动目录部分
      .dayLook_box {
        padding: 0 1.25rem 1.8125rem 1.25rem;
        .last_box {
          margin: 0.75rem 0 1.0625rem 0;
          font-size: 0.75rem;
          font-family: "Microsoft YaHei";
          font-weight: 400;
          color: #9e9e9e;
        }

        // 目录标题
        .muluTitle {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-content: center;
          margin-bottom: 1.375rem;
          .muluTitle_text {
            font-size: 1.125rem;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #000000;
          }
          .section_down {
            cursor: pointer;
            margin-right: 0.625rem;
            text-align: center;
            height: 100%;
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            align-items: center;
            font-size: 1rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #686868;
            span {
              margin-right: 0.5rem;
            }
            .icoUp {
              transform: rotate(180deg);
            }
          }
        }
      }

      // 购前必读部分
      .tips_box {
        padding: 0.5rem 1.25rem 0rem 1.25rem;
        margin-bottom: 1rem;
        border-bottom: 0.0625rem solid #f0f1f1;
        .tipsContentBox {
          margin-bottom: 1.875rem;
          background: #f8f8f8;
        }
      }

      // 学员分享部分
      .shart_box {
        width: 100%;
        height: auto;
        // 今日任务部分
        .today {
          padding: 1.875rem 1.75rem;
          // 当前任务标题
          .today_title {
            margin-bottom: 1.0625rem;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            // 左侧标题
            .left_today_title {
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: space-between;
              font-size: 1.25rem;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #84838b;
              line-height: 1.625rem;
              img {
                height: 1.1875rem;
                margin-right: 0.375rem;
              }

              // 当前任务类型
              .todayType{
                margin-left: 1rem;
                font-size: 1rem;
              }

              .MYcarStatus {
                // line-height: 0.155rem;
                display: inline-block;
                flex-shrink: 0;
                margin-left: 0.7125rem;
                padding: 0 0.25rem;
                border-radius: 0.1875rem;
                font-size: 0.5625rem;
                color: #fff;
                background-color: #d1d5d7;
                .icon-duigou {
                  color: #d1d5d7;
                }
              }

              .learn_rate {
                display: inline-block;
                flex-shrink: 0;
                margin-left: 0.7125rem;
                padding: 0 0.25rem;
                border-radius: 0.1875rem;
                font-size: 0.5625rem;
                color: #fff;
                background: #ff9e1c;
              }

              .cardOk {
                color: #fff;
                background-color: #24bf9d;
                .icon-duigou {
                  color: #24bf9d;
                }
              }
            }
            // 右侧任务数量
            .right_today_title {
              cursor: pointer;
              font-size: 1rem;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #666666;
              line-height: 1.625rem;
            }
          }
          // 当前任务盒子
          .today_box {
            padding: 2.5rem 1.875rem;
            background-color: #f5f7fa;
            border: 0.0625rem solid #e6edf2;
            border-left: 0.1875rem solid #afb4b8;
            // 下方第一行
            .onRow {
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: space-between;
              // 第一行标题部分

              .onRow_title {
                font-size: 1.125rem;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #6c707a;
                line-height: 1.625rem;
              }

              // 去学习按钮
              .Go {
                cursor: pointer;
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                width: 5.6875rem;
                height: 1.75rem;
                background: #26d3bc;
                border-radius: 0.125rem;

                font-size: 1.125rem;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #ffffff;
                line-height: 22px;

                -webkit-touch-callout: none;
                -webkit-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;
                user-select: none;
              }
              // 章节展开按钮
              .zankai {
                cursor: pointer;
                font-size: 1rem;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #686868;
                .iconfont::before {
                  color: #686868;
                  font-size: 0.5625rem;
                }
              }
            }

            // 第二行按钮部分
            .twoRow {
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: flex-start;
              .two_item {
                margin-top: 1.5625rem;
                margin-right: 0.5rem;
                cursor: pointer;
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                width: 5.6875rem;
                height: 1.75rem;
                background: #26d3bc;
                border-radius: 0.125rem;

                font-size: 1.125rem;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #ffffff;
                line-height: 22px;

                -webkit-touch-callout: none;
                -webkit-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;
                user-select: none;
              }
            }

            // 章节显示内容部分
            .knowledge {
              .knowledge_item {
                margin: 1.625rem 0;
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                align-items: center;
                .item_left {
                  display: flex;
                  flex-direction: row;
                  justify-content: flex-start;
                  align-items: center;

                  // 章节下面的小节是否完成
                  .ico {
                    visibility: hidden;
                  }
                  .ico.show {
                    visibility: visible;
                  }

                  .iconfont::before {
                    margin-right: 0.625rem;
                    color: #28bfa7;
                    font-size: 1rem;
                  }
                  .Number,
                  .title {
                    font-size: 1rem;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #686868;
                  }
                  .Number {
                    margin-right: 0.625rem;
                  }
                }
                .item_right {
                  display: flex;
                  flex-direction: row;
                  justify-content: flex-start;
                  align-items: center;
                  .is_ok {
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    align-items: center;
                  }
                  .btn {
                    margin-right: 0.5rem;
                    cursor: pointer;
                    display: flex;
                    flex-direction: row;
                    justify-content: center;
                    align-items: center;
                    width: 5.6875rem;
                    height: 1.75rem;
                    background: #26d3bc;
                    border-radius: 0.125rem;

                    font-size: 1.125rem;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #ffffff;
                    line-height: 22px;

                    -webkit-touch-callout: none;
                    -webkit-user-select: none;
                    -moz-user-select: none;
                    -ms-user-select: none;
                    user-select: none;
                  }
                }
              }
              .two_item {
                margin-top: 1.5625rem;
                margin-right: 0.5rem;
                cursor: pointer;
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;
                width: 5.6875rem;
                height: 1.75rem;
                background: #26d3bc;
                border-radius: 0.125rem;

                font-size: 1.125rem;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #ffffff;
                line-height: 22px;

                -webkit-touch-callout: none;
                -webkit-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;
                user-select: none;
              }
            }
          }

          // 完成学习内容但是没有写日记部分
          .diary {
            margin-top: 0.9375rem;
            padding: 0.8125rem;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            height: 40px;
            background: #f8f8f8;
            border-radius: 0.1875rem;

            font-size: 0.875rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #666666;
            line-height: 1.375rem;
            .GoDiary {
              text-decoration: underline;
              margin-left: 10px;
              cursor: pointer;
              color: #ffba61;
            }
            .icon-jiantou {
              transform: scale(0.8);
            }
            .icon-jiantou::before {
              font-size: 0.5625rem;
              color: #ffba61;
            }
          }
        }

        // 分享按钮
        .shard_btn_box {
          padding: 1.5625rem 2.4375rem;
          border-bottom: 0.0625rem solid#F0F1F1;
          .shard_btn {
            // width: 52.0625rem;
            height: 3.375rem;
            background: #ff7862;
            border-radius: 0.125rem;
            font-size: 1rem;
            font-family: "Microsoft YaHei";
            font-weight: bold;
            color: #ffffff;
            text-align: center;
            line-height: 3.375rem;
            cursor: pointer;
          }
        }
        // 其他学员打卡日记部分
        .share_comment_box {
          padding: 0 1.75rem 1.875rem;
          // 标题部分
          .share_comment_title {
            padding-bottom: 1.3125rem;
            margin-bottom: 1.0625rem;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            border-bottom: 0.0625rem solid #f0f1f1;

            // 左侧标题
            .left_today_title {
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: space-between;
              font-size: 1.25rem;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #84838b;
              line-height: 1.625rem;
              img {
                height: 1.1875rem;
                margin-right: 0.375rem;
              }
            }
            // 右侧任务数量
            .right_today_title {
              cursor: pointer;
              font-size: 1rem;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #666666;
              line-height: 1.625rem;
              /deep/ .el-select {
                // width: 1.875rem !important;
                .el-input__inner {
                  padding: 0;
                  border: none;
                  width: 6rem;
                  font-size: 1rem;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #666666;
                  line-height: 1.625rem;
                }
              }
            }
          }
          //分享内容部分
          .share_comment {
            width: 100%;
            height: auto;
            /deep/ .sharCard {
              margin-top: 0;
              width: 100%;
              border-left: none;
              border-right: none;
              border-top: none;
            }
          }
          // 查看更多
          .more {
            width: 100%;
            height: 4.4375rem;
            font-size: 0.875rem;
            font-family: "Microsoft YaHei";
            font-weight: 400;
            color: #424242;
            text-align: center;
            line-height: 4.4375rem;
            cursor: pointer;
            .icon-jiantou:before {
              margin-left: 0.3125rem;
              font-size: 0.375rem;
              font-weight: 400;
              color: #424242;
            }
          }
        }
      }
      .giveClass_box{
        padding: 0 1.25rem 1.8125rem 1.25rem;
      }
    }
  }
  // 下方右侧讲师介绍部分盒子
  .right_box {
    width: 24rem;
    height: auto;
    // background: #ffffff;
    // box-shadow: 0px 0.125rem 0.375rem 0rem rgba(212, 214, 216, 0.3);
    // 数据仪表盘部分
    .studyData {
      box-shadow: 0px 0.125rem 0.375rem 0rem rgba(212, 214, 216, 0.3);
      margin-bottom: 1.25rem;
      width: 100%;
      height: auto;
      background-color: #fff;
      .studyData_top {
        padding: 0 2rem;
        height: 7.5rem;
        border-bottom: 1px solid #f4f4f4;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        .studyData_top_item {
          cursor: pointer;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .img_box {
            margin-bottom: 0.625rem;
            width: 2.4375rem;
            height: 2.4375rem;
            background: #ffc052;
            border-radius: 50%;

            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            .iconfont::before {
              font-size: 1.25rem;
              color: #fff;
            }
          }
          .text {
            font-size: 0.875rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #757c82;
            line-height: 1.625rem;
          }
        }
        .studyData_top_item:hover {
          .text {
            color: #ffba61;
          }
        }
      }

      // 仪表盘新增的排行榜部分
      .topSearch_box {
        /deep/ .topSrarch {
          width: auto;
          .topSrarch_bottom {
            padding: 0 2rem 0 2.3125rem;
          }
        }
      }
    }
    // 联系我们部分
    .link {
      box-shadow: 0px 0.125rem 0.375rem 0rem rgba(212, 214, 216, 0.3);
      padding: 1.875rem;
      margin-bottom: 0 !important;
      .icon {
        text-align: center;
        img {
          width: 5.125rem;
          height: 5.125rem;
        }
      }
      .link_text {
        margin: 1.375rem 0 2.5625rem;
        text-align: center;
        font-size: 1.5rem;
        font-family: " Microsoft YaHei";
        font-weight: 400;
        color: #424966;
        line-height: 1.375rem;
      }
      .link_btn {
        margin: auto;
        width: 9.75rem;
        height: 2.625rem;
        background: #ffffff;
        border: 0.0625rem solid #ffc2b4;
        border-radius: 0.25rem;
        button {
          height: 100%;
          width: 100%;
          border: none;
          font-size: 1.125rem;
          font-family: " Microsoft YaHei";
          font-weight: 400;
          color: #ff886d;
          line-height: 2.625rem;
          background-color: #fff;
          border-radius: 0.25rem;
        }
      }
    }
    // 右侧盒子公用样式
    .rightBox {
      width: 100%;
      background: #ffffff;
      box-shadow: 0px 0.125rem 0.375rem 0rem rgba(212, 214, 216, 0.3);
      margin-bottom: 1.5rem;
    }
    .rightBox:last-child {
      margin-bottom: none;
    }

    // 微信二维码加群部分
    .qrCode {
      margin-top: 1.4375rem;
      padding: 1.25rem 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 16.875rem;
      background: #ffffff;
      box-shadow: 0px 2px 6px 0px rgba(212, 214, 216, 0.3);

      font-size: 1.25rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #4c4c4c;
      .qr {
        margin-top: 2.0875rem;
        width: 10.375rem;
        height: 10.375rem;
        // background-color:red;
        img {
          width: 100%;
        }
      }
    }
  }
  // 资料下载栏
  .data_box {
    padding: 0 1.25rem 0.9125rem 1.25rem;
  }
  .data {
    // margin-bottom: 1.5625rem;
    padding: 0.3125rem 0 5px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 3.375rem;
    background: #f5f5f5;
    border-radius: 0.125rem;
    .data_left {
      padding: 0.3125rem 0;
      margin-left: 1.1875rem;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      .ico_tuwen {
        width: 1.3125rem;
        height: 1.3125rem;
        border-radius: 50%;
        background-color: #ced5da;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        .icon-xuexiziliao::before {
          color: #fff;
          font-size: 0.5625rem;
        }
      }
      .data_name {
        margin: 0 1.25rem 0 0.5rem;
        color: #686868;
        font-size: 1rem;
        // font-weight: Bold;
      }
    }
    .data_right {
      flex-shrink: 0;
      margin-right: 0.6875rem;
      width: 5.5rem;
      height: 1.9375rem;
      .btn {
        text-align: center;
        line-height: 1.9375rem;
        width: 100%;
        height: 100%;
        background-color: #ff7d3a;
        font-size: 0.875rem;
        font-family: "Microsoft YaHei";
        font-weight: 400;
        color: #ffffff;
        border: 0.0625rem solid #e8e8e8;
        border-radius: 0.1875rem;
        cursor: pointer;
      }
    }
  }
}
</style>